import { InjectionToken } from '@angular/core';

/**
 * Bridge interface for the AngularJS TenantService.
 * Used by AuthenticationService while the underlying service has not been migrated to Angular 18.
 *
 * Reference: apps/b2b-ui/common/services/tenant/tenant.service.js
 */
export interface ITenantPort {
  model: Record<string, unknown>;
  setModel(data: unknown): void;
  isRecurringPaymentEnabled(): boolean;
}

export const TENANT_PORT = new InjectionToken<ITenantPort>('TENANT_PORT');
